import { MouseEventHandler, useState } from "react";

interface Props {
  onClick?: MouseEventHandler;
  style?: any;
  className?: string;
  backgroundColor?: string;
  hoverColor?: string;
  hoverTextColor?: string;
  children: any;
  enableHover?: boolean;
  boxShadow?: string;
  hoverBoxShadow?: string;
  padding?: string;
  showCursor?: boolean;
  domId?: string;
}

export default function RoundedContentBox(props: Props) {
  const [isHover, setIsHover] = useState(false);

  let backgroundColor = "#ffffff";
  let textColor = "#000000";
  let hoverColor = "#8c1ec8";

  if (props.backgroundColor) {
    backgroundColor = props.backgroundColor;
  }

  if (props.hoverColor) {
    hoverColor = props.hoverColor ? props.hoverColor : hoverColor;
  }
  if (props.hoverTextColor) {
    textColor = props.hoverTextColor ? props.hoverTextColor : textColor;
  }

  const handleMouseEnter = () => {
    if (props.enableHover) setIsHover(true);
  };

  const handleMouseLeave = () => {
    if (props.enableHover) setIsHover(false);
  };

  const defaultBoxShadow = "0px 8px 24px -4px #E0E0E040";
  const defaultHoverBoxShadow = `0 0 5px ${hoverColor}`;

  const contentBoxStyle = {
    backgroundColor: backgroundColor,
    boxShadow: isHover
      ? (props.hoverBoxShadow ?? defaultHoverBoxShadow)
      : (props.boxShadow ?? defaultBoxShadow),
    transition: props.enableHover ? "box-shadow 0.2s ease" : undefined,
    padding: props.padding ? props.padding : "1.5rem",
    borderRadius: "0.75rem",
    gap: "1rem",
    overflow: "hidden",
    color: textColor,
    cursor: props.showCursor ? "pointer" : "",
    boxSizing: "border-box",
    ...props.style,
  } as React.CSSProperties;

  return (
    <div
      id={props.domId}
      onClick={props.onClick}
      style={contentBoxStyle}
      className={props.className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {props.children}
    </div>
  );
}
